import React from 'react';
import paypalLogo from '../../../../../assets/images/billing/paypal.svg';

function PayPalFormHeader() {
    return <div className="paypal-form-header">
        <img className="paypal-logo" src={paypalLogo} />
    </div>;
}

export default PayPalFormHeader;
